// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3WG_y","subheader":"ReorderModal_subheader__1Gs3j","listWrap":"ReorderModal_listWrap__Snu7R"};